import { Button } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';

export const NavButton = withStyles((theme) => ({
    root: {
        height: '100%',
        borderRadius:'0px !important',
    }
}))(Button);